import * as XLSX from 'xlsx-js-style';
import { Client } from '../types';
import axiosInstance from './axiosInstance';

// Бренд-токени зі специфікації WordCraft:
// бірюза #0a8a88, заголовок #07403f, світлий фон #f3f7f6, текст #5d726f.
const BRAND = '0A8A88';
const HEADER_TEXT = 'FFFFFF';
const ROW_LIGHT = 'F3F7F6';
const ROW_WHITE = 'FFFFFF';
const TEXT_DARK = '07403F';
const TEXT_MUTED = '5D726F';
const OK = '0A8A88';
const NO = 'C0392B';
const BORDER = 'D8E6E4';

const HEADERS = [
  '№',
  'ПІБ клієнта',
  'Email',
  'Телефон',
  'Тариф',
  'Дата реєстрації',
  'Останній вхід',
  'Пошта підтверджена',
  'Коментар',
];

const thin = { style: 'thin', color: { rgb: BORDER } };
const BORDER_ALL = { top: thin, bottom: thin, left: thin, right: thin };

const fmtDate = (v?: string) =>
  v
    ? new Date(v).toLocaleDateString('uk-UA', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      })
    : '—';

const fmtDateTime = (v?: string) =>
  v
    ? new Date(v).toLocaleString('uk-UA', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    : '—';

const headerStyle = () => ({
  fill: { fgColor: { rgb: BRAND } },
  font: { name: 'Nunito', bold: true, sz: 12, color: { rgb: HEADER_TEXT } },
  alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
  border: BORDER_ALL,
});

const bodyColor = (col: number, value: string) => {
  if (col === 7) return value === 'Так' ? OK : NO;
  if (col === 8) return TEXT_MUTED;
  return TEXT_DARK;
};

const bodyStyle = (row: number, col: number, value: string) => ({
  fill: { fgColor: { rgb: row % 2 === 0 ? ROW_LIGHT : ROW_WHITE } },
  font: {
    name: 'Nunito',
    sz: 11,
    bold: col === 7,
    color: { rgb: bodyColor(col, value) },
  },
  alignment: {
    horizontal: col === 0 || col === 7 ? 'center' : 'left',
    vertical: 'center',
    wrapText: col === 8,
  },
  border: BORDER_ALL,
});

/**
 * Тягне ВЕСЬ перелік клієнтів, що відповідає поточному пошуку/сортуванню
 * (в обхід пагінації списку), щоб вивантажити саме те, що показано на сторінці.
 */
export const fetchAllClients = async (
  orderDirection: string,
  searchString: string,
  orderBy: string,
): Promise<Client[]> => {
  const res = await axiosInstance.post('/Admin/GetClientsList', {
    pageIndex: 1,
    pageSize: 100000,
    searchString,
    orderDirection,
    orderBy,
  });
  return res.data?.items ?? [];
};

/** Генерує стилізований .xlsx (у стилі специфікації) і запускає завантаження. */
export const exportClientsToExcel = (clients: Client[]) => {
  const rows = clients.map((c, i) => [
    i + 1,
    c.userName || '',
    c.email || '',
    c.phone || '',
    'Без договору',
    fmtDate(c.createdAt),
    fmtDateTime(c.lastLoginAt),
    c.emailConfirmed ? 'Так' : 'Ні',
    c.comment || '',
  ]);

  const ws = XLSX.utils.aoa_to_sheet([HEADERS, ...rows]);
  const range = XLSX.utils.decode_range(ws['!ref'] as string);

  for (let R = range.s.r; R <= range.e.r; R++) {
    for (let C = range.s.c; C <= range.e.c; C++) {
      const cell = ws[XLSX.utils.encode_cell({ r: R, c: C })];
      if (!cell) continue;
      cell.s = R === 0 ? headerStyle() : bodyStyle(R, C, String(cell.v));
    }
  }

  ws['!cols'] = [
    { wch: 5 },
    { wch: 26 },
    { wch: 30 },
    { wch: 16 },
    { wch: 14 },
    { wch: 15 },
    { wch: 18 },
    { wch: 18 },
    { wch: 36 },
  ];
  ws['!rows'] = [{ hpt: 32 }];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Клієнти');

  const stamp = new Date().toISOString().slice(0, 10);
  XLSX.writeFile(wb, `WordCraft_Клієнти_${stamp}.xlsx`);
};
